import useScrolledPast from '../libs/utils/useScrolledPast'

const ScrollTopButton = ({ showOffset, tooltip, label }) => {

  const show = useScrolledPast(showOffset)

  // Native smooth scrolling: no animation library in the bundle every page loads
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <button
      type='button'
      aria-label={label || tooltip}
      // Hidden off-screen until scrolled: keep it out of keyboard navigation too
      tabIndex={show ? 0 : -1}
      className={`btn-scroll-top${show ? ' show' : ''}`}
      onClick={scrollToTop}
    >
      <span className='btn-scroll-top-tooltip text-muted fs-sm me-2' aria-hidden='true'>{tooltip}</span>
      <i className='btn-scroll-top-icon fi-chevron-up' aria-hidden='true'></i>
    </button>
  )
}

export default ScrollTopButton
